import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Reports() {
  return (
    <ScaffoldPage
      title="Compliance Reports"
      description="Generate and export compliance reports for auditors and stakeholders."
      breadcrumbs={buildBreadcrumbs('/settings/compliance/reports')}
      plannedFeatures={[
        'SOC 2 compliance report generation',
        'GDPR processing activity records',
        'Data retention compliance summaries',
        'Scheduled report delivery via email',
        'Custom report templates',
      ]}
      relatedPages={[
        { label: 'Compliance Status', href: '/settings/compliance/status' },
        { label: 'Global Audit Log', href: '/settings/compliance/audit' },
      ]}
    />
  )
}
